"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Cache = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var Cache =
/*#__PURE__*/
function () {
  function Cache(init) {
    var _this = this;

    (0, _classCallCheck2["default"])(this, Cache);
    hide(this, 'hide', function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return hide.apply(void 0, [_this].concat(args));
    });
    this.clear(init);

    this.write = function (k, v) {
      return _this.set(k, v).get(k);
    };
  }

  (0, _createClass2["default"])(Cache, [{
    key: "fetch",
    value: function fetch(k, defaultValue) {
      if (this.has(k)) {
        return this.get(k);
      } else {
        this.set(k, typeof defaultValue === 'function' ? defaultValue(k) : defaultValue);
        return this.get(k);
      }
    }
  }, {
    key: "clear",
    value: function clear(init) {
      delete this._wm;
      this._wm = new Map(init);
    }
  }, {
    key: "delete",
    value: function _delete(k) {
      return this._wm["delete"](k);
    }
  }, {
    key: "get",
    value: function get(k) {
      return this._wm.get(k);
    }
  }, {
    key: "has",
    value: function has(k) {
      return this._wm.has(k);
    }
  }, {
    key: "set",
    value: function set(k, v) {
      this._wm.set(k, v);

      return this;
    }
  }]);
  return Cache;
}();

exports.Cache = Cache;
var _default = Cache;
exports["default"] = _default;

function hide(target, propName, value) {
  var configurable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  Object.defineProperty(target, propName, {
    enumerable: false,
    configurable: configurable,
    value: value
  });
  return target;
}